import { Trans, useTranslation } from '@e-kyc/translations';

import { Button, Modal, WarningRoundedOutlinedIcon } from '../../../../../../components';

interface IdCardConfirmationProps {
  isOpen: boolean;
  close: () => void;
  onSubmit: () => void;
  isLoading: boolean;
}

function IdCardConfirmationModal(props: Readonly<IdCardConfirmationProps>) {
  const { isOpen, onSubmit, close, isLoading } = props;

  const { t } = useTranslation();

  return (
    <Modal open={isOpen} className='w-full max-w-[343px]'>
      <div className='flex w-full flex-col items-center justify-center'>
        <div className='flex flex-col items-center justify-center gap-4 p-6 pt-10'>
          <WarningRoundedOutlinedIcon className='text-primary size-12' />
          <div className='flex flex-col items-center justify-center gap-2'>
            <h5 className='font-semibold'>{t('idCardDetails.modal.confirmation.title')}</h5>
            <div className='text-body-1 text-text-secondary text-center'>
              <Trans i18nKey='idCardDetails.modal.confirmation.description' />
            </div>
          </div>
        </div>
        <div className='flex w-full flex-col gap-2 p-4'>
          <Button className='w-full' type='submit' onClick={onSubmit} loading={isLoading}>
            {t('button.confirm')}
          </Button>
          <Button
            className='w-full'
            variant='outlined'
            onClick={() => {
              close();
            }}
            disabled={isLoading}
          >
            {t('button.cancel')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default IdCardConfirmationModal;
